module.exports = __webpack_public_path__ + "static/img/no_meeting.832c432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/no_meeting.png
// module id = 5SWi
// module chunks = 4